<template>
  <div class="add-pro-wrapper">
    <!-- 标题与保存按钮 -->
    <el-row>
      <el-col :span="12"><Title title="修改音效"></Title></el-col>
      <el-col :span="12">
        <div style="width:100%;height:60px;padding-right:15px;box-sizing:border-box" class="flex_rec">
          <el-button type="primary" @click="save" :loading="isSaving">保存修改</el-button>
        </div>
      </el-col>
    </el-row>

    <div class="add-pro-content">
      <el-row :gutter="15">
      <!-- 左模块 -->
        <el-col :span="18">
          <!-- 基本信息 -->
          <el-card class="box-card">
            <el-row :gutter="20">
              <!-- 左边 -->
              <el-col :span="4">
                <div class="part-info">
                  <div class="title">基本</div>
                  <div class="info">音效信息</div>
                </div>
              </el-col>
              <!-- 右边 -->
              <el-col :span="20">

                <!-- 名称 -->
                <el-row :gutter="20" class="mt10">
                  <el-col :span="24">
                      <el-input placeholder="请输入内容" v-model="form.name">
                        <template slot="prepend">名称</template>
                      </el-input>
                  </el-col>
                </el-row>

                <!-- 2026-10-11：编辑已有音效时允许切换资源来源。保存请求只提交当前选中的
                一种来源，避免旧外链和新上传文件同时出现时被服务端优先识别为外链。 -->
                <el-row :gutter="20" class="mt10">
                  <el-col :span="24">
                    <div class="source-type-selector">
                      <span class="source-type-label">资源来源</span>
                      <el-radio-group v-model="addSourceType">
                        <el-radio-button label="localFile">本地上传</el-radio-button>
                        <el-radio-button label="linkUrl">网络外链</el-radio-button>
                      </el-radio-group>
                      <span class="source-type-help">只有保存成功后才会替换当前资源，保存失败不会破坏原资源。</span>
                    </div>
                    <el-alert
                      v-if="originalSourceType && originalSourceType !== addSourceType"
                      class="source-switch-alert"
                      :title="isLinkType ? '保存后将从本地文件切换为网络外链' : '保存后将从网络外链切换为本地文件，请先选择新文件'"
                      type="warning"
                      :closable="false"
                      show-icon>
                    </el-alert>
                  </el-col>
                </el-row>

                <!-- 完整地址 -->
                <!-- 选项：自定义地址 / 网易云外链 -->
                <el-row :gutter="20" class="mt10" v-if="isLinkType">
                  <el-col :span="24">
                    <el-radio-group v-model="link_type" @change="onLinkTypeChange">
                      <el-radio label="custom">自定义地址</el-radio>
                      <el-radio label="netease">网易云外链</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-row>

                <!-- 输入区：根据选项切换 -->
                <el-row :gutter="20" class="mt10" v-if="isLinkType">
                  <!-- 自定义：整条 URL 由用户输入 -->
                  <el-col :span="24" v-if="link_type === 'custom'">
                    <el-input
                      v-model.trim="form.full_path"
                      clearable
                      placeholder="请输入完整外链地址，如 https://example.com/a.mp3">
                      <template slot="prepend">外链地址</template>
                    </el-input>
                  </el-col>

                  <!-- 网易云：只填 ID，前缀固定 -->
                  <el-col :span="24" v-else>
                    <el-input
                      v-model.trim="netease_id"
                      clearable
                      placeholder="请输入网易云歌曲ID，如 1854998259"
                      @input="onlyDigits('netease_id')"
                      @paste.native="parseNeteasePaste">
                      <template slot="prepend">{{ NETEASE_PREFIX }}</template>
                    </el-input>
                    <!-- 可选：给用户一个最终链接的预览 -->
                    <div class="mt5" style="font-size:12px;color:#909399;">
                      最终链接：<code style="word-break:break-all;">{{ computedFullPath }}</code>
                    </div>
                  </el-col>
                </el-row>

                <!-- 2026-09-29：外链只校验地址格式，不保证远端资源一直可用；例如链接失效时需重新编辑地址。 -->
                <el-row :gutter="20" class="mt10" v-if="isLinkType">
                  <el-col :span="24">
                    <el-alert
                      title="外链可能失效"
                      description="保存时只校验地址格式，不检查远端音频是否可播放。保存后请点击下方试听确认；如果链接失效，请更新外链地址。"
                      type="info"
                      :closable="false"
                      show-icon>
                    </el-alert>
                  </el-col>
                </el-row>

                <!-- 内容描述 -->
                <el-input
                  type="textarea"
                  style="margin-top:10px"
                  :autosize="{ minRows: 4, maxRows: 6}"
                  placeholder="请输入内容"
                  v-model="form.discription">
                </el-input>
                <!-- 旧版扩展关键词 -->
                <span class="p-extra mb5">
                  旧版扩展关键词（兼容旧客户端，多个词用逗号隔开）。新的搜索词请在下方“标签与搜索词”中维护。
                </span>
              </el-col>
            </el-row>
          </el-card>

          <!-- 文件上传 -->
          <el-card class="box-card" v-if="!isLinkType">
            <el-row :gutter="20">
              <!-- 左边 -->
              <el-col :span="3">
                <div class="part-info">
                  <div class="title">文件</div>
                  <div class="info">文件上传</div>
                </div>
              </el-col>
              <!-- 右边 -->
              <el-col :span="21">
                <el-card shadow="never" class="mb10">
                  <!-- 2026-09-28：只展示服务端给出的安全相对路径，不暴露磁盘根目录。 -->
                  <div class="resource-summary">
                    <div class="resource-summary-row">
                      <span class="resource-summary-label">资源来源</span>
                      <el-tag :type="soundSourceTagType(form.media_source)">
                        {{ soundSourceLabel(form.media_source) }}
                      </el-tag>
                    </div>
                    <div class="resource-summary-row">
                      <span class="resource-summary-label">当前路径</span>
                      <code class="resource-summary-path">{{ form.resource_path || '无可用路径' }}</code>
                    </div>
                    <div class="resource-summary-row">
                      <span class="resource-summary-label">文件状态</span>
                      <el-tag :type="resourceStatusTagType(form.resource_status)">
                        {{ resourceStatusLabel(form.resource_status) }}
                      </el-tag>
                    </div>
                    <el-alert
                      v-if="form.resource_status !== 'available'"
                      class="resource-summary-alert"
                      title="当前本地资源不可正常使用。请选择并上传新文件后再保存；不上传新文件时，服务端会拒绝把音效绑定到缺失资源。"
                      type="warning"
                      :closable="false"
                      show-icon>
                    </el-alert>
                  </div>
                </el-card>

                <el-upload
                  class="upload-demo"
                  drag
                  action=""
                  ref="uploadHandler"
                  :auto-upload="false"
                  name="soundFile"
                  :multiple="false"
                  list-type="text"
                  :file-list="selectedFileList"
                  :on-change="selectFileChange"
                  :on-remove="fileRemove"
                  :on-exceed="fileExceed"
                  :on-preview="handlePreview"
                  >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传flac,m4a,mp3,wav,ogg,aac文件，且不超过10m</div>
                </el-upload>
                <!-- 上传进度面板（新增） -->
                <div v-if="upload.state !== 'idle'" class="upload-progress">
                  <div class="up-head">
                    <span class="up-name">{{ upload.fileName }}</span>
                    <span class="up-meta">{{ prettyBytes(upload.loaded) }} / {{ prettyBytes(upload.total) }}</span>
                  </div>

                  <el-progress :percentage="upload.percent" :status="upload.status"></el-progress>

                  <div class="up-row">
                    <span>速度：{{ prettyBytes(upload.speed) }}/s</span>
                    <span>剩余：{{ etaText }}</span>
                  </div>

                  <div class="up-ops">
                    <el-button v-if="upload.state==='uploading'" size="mini" @click="cancelUpload">取消</el-button>
                    <!-- <el-button v-else size="mini" @click="fileRemove">重新上传</el-button> -->
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card audio-preview-card">
            <!-- 2026-09-29：试听由管理员主动触发；按钮和播放器分区展示。 -->
            <div class="audio-preview-header">
              <div>
                <div class="audio-preview-title">当前音效试听</div>
                <div class="audio-preview-help">点击下方播放键试听；地址失效时可重新获取。</div>
              </div>
              <el-button size="small" :disabled="!form.id" @click="refreshPreview">
                重新获取并试听
              </el-button>
            </div>
            <Player class="audio-preview-player" :currSrc="currSrc" ref="player"></Player>
          </el-card>
          <el-card class="box-card sound-metadata-card" v-if="form.id">
            <div slot="header" class="clearfix">
              <strong>资源信息与正文</strong>
              <span class="metadata-card-tip">这里的修改单独保存，不受顶部按钮影响</span>
            </div>
            <SoundResourceContentEditor :sound-id="form.id"></SoundResourceContentEditor>
          </el-card>
          <el-card class="box-card sound-metadata-card" v-if="form.id">
            <div slot="header" class="clearfix">
              <strong>标签与搜索词</strong>
              <span class="metadata-card-tip">这里的修改单独保存，不受顶部按钮影响</span>
            </div>
            <SoundTagSearchEditor :sound-id="form.id"></SoundTagSearchEditor>
          </el-card>
          <el-card class="box-card sound-metadata-card" v-if="form.id">
            <div slot="header" class="clearfix">
              <strong>版权与展示控制</strong>
              <span class="metadata-card-tip">这里的修改单独保存，并保留完整审核记录</span>
            </div>
            <SoundRightsAssignmentEditor :sound-id="form.id"></SoundRightsAssignmentEditor>
          </el-card>
        </el-col>

        <!-- 右模块 -->
        <el-col :span="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>状态</span>
            </div>
            <p class="p-extra mb5">启用状态(用户是否可见)</p>
            <el-select v-model="form.status" placeholder="请选择账号状态" style="width:100%" class="mb10">
              <el-option
                v-for="item in status_arr"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            <p class="p-extra mb5">推荐状态(是否显示在最近上传)</p>
            <el-select v-model="form.recommend" placeholder="请选择推荐状态" style="width:100%" class="mb10">
              <el-option
                v-for="item in status_arr"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            <p class="p-extra mb5">分类(归属的基础分类)</p>
            <el-select v-model="form.category_id" placeholder="请选择分类" style="width:100%">
              <el-option
                v-for="item in category_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>

            <el-input placeholder="请输入内容" v-model="form.wnb" style="width:100%;margin-top:10px">
              <template slot="prepend">下载所需币</template>
            </el-input>
          </el-card>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import Title from "./components/Title"
import apis from "@/api/index"
import Player from "@/components/Player.vue"
import SoundResourceContentEditor from "@/components/sounds/SoundResourceContentEditor.vue"
import SoundTagSearchEditor from "@/components/sounds/SoundTagSearchEditor.vue"
import SoundRightsAssignmentEditor from "@/components/sounds/SoundRightsAssignmentEditor.vue"
import {
  resourceStatusLabel,
  resourceStatusTagType,
  soundSourceLabel,
  soundSourceTagType
} from '@/lib/soundAdminUi'
import axios from 'axios'
export default {
  name:'addProducts',
    components:{
      Title,
      Player,
      SoundResourceContentEditor,
      SoundTagSearchEditor,
      SoundRightsAssignmentEditor
    },
    data(){
      return{
        NETEASE_PREFIX: 'http://music.163.com/song/media/outer/url?id=',
        link_type:'custom',// 'custom' | 'netease'
        netease_id: '',         // 仅当 link_type = 'netease' 时使用
        form:{ 
          wnb:0,
          status:1,
          recommend:1,
          full_path: '',         // 提交给后端的一致字段
        },
        status_arr:[
          {name:'启用/激活/推荐',value:1},
          {name:'禁用/未激活/不推荐',value:0},
          {name:'未设置',value:null},
        ],   
        devices_list:[],
        category_list:[],
        currSrc:"",
        // 新增：上传状态
        upload:{
          state: 'idle',     // idle | uploading | success | error
          status: undefined, // el-progress 的状态
          fileName: '',
          percent: 0,
          loaded: 0,
          total: 0,
          speed: 0,
          lastTs: 0,
          lastLoaded: 0,
          cancelSource: null
        },
        addSourceType:this.$route.params.addSourceType || "localFile", // 新增：来源类型（localFile：本地上传，linkUrl：外链）
        originalSourceType:'', // 2026-10-11：记录进入页面时的来源，用于识别是否正在切换资源。
        isSaving:false, // 新增：保存按钮状态
        selectedFileList: [], // 新增：选中的文件列表
      }
    },
    methods:{
      // 2026-09-28：所有展示文案都由统一状态码映射，页面不自行猜测来源。
      resourceStatusLabel,
      resourceStatusTagType,
      soundSourceLabel,
      soundSourceTagType,
      async save(){
        this.isSaving = true

        // 1) 必填校验（避免无意义的上传）
        if (!this.form.name) {
          this.$message.error('请输入名称');
          this.isSaving = false;
          return;
        }
        if (!this.form.category_id) {
          this.$message.error('请先选择分类');
          this.isSaving = false;
          return;
        }

        // 把现有 this.form 转成 FormData（保留你原来的做法）
        const presentationFields = new Set([
          'media_url',
          'media_url_expires_at',
          'media_source',
          'resource_path',
          'resource_exists',
          'resource_status',
          'path',
          'hostname',
          // 2026-10-11：资源字段必须按当前选中的来源单独追加，不能把隐藏的
          // 旧外链、旧资源 ID 和新文件一次性提交给服务端。
          'full_path',
          'audio_asset_id',
          'sound'
        ])
        const formArr = Object.entries(this.form)
          .filter(([key]) => !presentationFields.has(key))
        let formData = new FormData();
        formArr.forEach(([k,v])=>{
          if(v !== null && v !== undefined){
            formData.append(k, v)
          }
        })

        // 隐藏的文件选择不能影响外链保存。例如先选文件、再改选“网络外链”时，
        // 请求中只应有 full_path，也不应显示伪造的上传进度。
        const hasNewFile = !this.isLinkType && Boolean(this.form.sound)
        if (this.isLinkType) {
          const externalUrl = String(this.computedFullPath || '').trim()
          if (!externalUrl) {
            this.$message.error('请输入外链地址')
            this.isSaving = false
            return
          }
          formData.append('full_path', externalUrl)
        } else if (hasNewFile) {
          formData.append('sound', this.form.sound)
        } else if (Number(this.form.audio_asset_id || 0) > 0) {
          // 本来就是本地资源且没有选择新文件时，继续绑定已有 file_asset。
          formData.append('audio_asset_id', this.form.audio_asset_id)
        } else {
          this.$message.error('切换为本地上传时，请先选择要上传的音频文件')
          this.isSaving = false
          return
        }

        // 2026-10-11：只有真正上传新文件才显示上传进度。修改外链或继续使用
        // 已有本地资源时走普通保存，避免出现空文件名和假上传进度。
        if (!hasNewFile) {
          try{
            const res = await apis.sounds.update(formData)
            if(res.data.code == 1){
              this.$message({message:"修改成功", type:"success"})
              this.$router.push({name:'soundsList'})
            }else{
              this.$message({message:res.data.msg,type:'error'})
            }
          }catch(e){
            this.$message({message:String(e), type:'error'})
          }
          this.isSaving = false;
          return
        }

        // 分支2：上传新的本地文件，使用 axios + onUploadProgress。

        // 初始化进度
        this.upload = {
          state: 'uploading',
          status: undefined,
          fileName: this.form.sound?.name || '',
          percent: 0,
          loaded: 0,
          total: this.form.sound?.size || 0,
          speed: 0,
          lastTs: performance.now(),
          lastLoaded: 0,
          cancelSource: axios.CancelToken.source()
        }

        try{
          console.log('formData',formData)
          let upResult = await apis.sounds.update(formData, {
            cancelToken: this.upload.cancelSource.token,
            onUploadProgress: (e) => {
              if(!e.total) return
              const now = performance.now()
              this.upload.total = e.total
              this.upload.loaded = e.loaded
              this.upload.percent = Math.round(e.loaded * 100 / e.total)

              // 500ms 更新一次速度
              const dt = (now - this.upload.lastTs) / 1000
              if (dt >= 0.5) {
                const dBytes = e.loaded - this.upload.lastLoaded
                this.upload.speed = dBytes / dt
                this.upload.lastTs = now
                this.upload.lastLoaded = e.loaded
              }
            }
          })

          console.log('upResult',upResult)
          if(upResult.data.code == 1){
            this.upload.state = 'success'
            this.upload.status = 'success'
            this.$message({message:"上传并修改成功", type:"success",duration:0,showClose: true})
            this.$router.push({name:'soundsList'})
          }else{
            this.upload.state = 'success'
            this.upload.status = 'warning'
            // this.$message({message:upResult.data.msg,type:'error',duration:0,showClose: true})
            let errorMsg = upResult.data.msg || '上传失败'
            this.clearSelectedFiles(errorMsg)
            this.isSaving = false;
            
          }
          
          
        }catch(err){
          if (axios.isCancel(err)) {
            this.$message({message:"已取消上传", type:"info"})
            this.upload.state = 'idle'
            this.isSaving = false;
          } else {
            this.upload.state = 'error'
            this.upload.status = 'exception'
            this.isSaving = false
            this.$message({message:`上传失败：${err?.message || '网络异常'}`, type:'error',duration:0,showClose: true})
          }

        }
      },
      cancelUpload(){
        if (this.upload.cancelSource) {
          this.upload.cancelSource.cancel('user cancel')
        }
      },

      prettyBytes(n){
        if (n === 0) return '0 B'
        if (!n && n !== 0) return '--'
        const u = ['B','KB','MB','GB']; let i=0; let x=n
        while (x>=1024 && i<u.length-1) { x/=1024; i++ }
        return x.toFixed(x>=100||i===0?0:1)+' '+u[i]
      },
      getCategoryList(){
        apis.category.read(0).then(res=>{
          console.log('res',res)
          this.category_list = res.data.data
        }).catch(err=>{
          console.log('err',err)
        })
      },

      handlePreview(file) {
        let f = file.raw;
        this.$refs.player.play({
          src:window.URL.createObjectURL(f),
          name:f.name
        })
      },
      /**
       * 2026-09-28：本地音效的试听票据会过期。管理员重新试听时只刷新
       * 服务端签发的播放地址，不重载编辑表单，避免覆盖尚未保存的修改。
       * 例如页面打开半小时后点击此按钮，仍能试听当前已保存的音效。
       */
      async refreshPreview() {
        try {
          const response = await apis.sounds.readOneSound({ id: this.form.id })
          const sound = response?.data?.data
          if (response?.data?.code !== 1) {
            this.$message.error(response?.data?.msg || '获取试听地址失败')
            return
          }
          if (!sound?.media_url) {
            this.$message.warning('当前音效没有可用的试听地址')
            return
          }
          this.currSrc = sound.media_url
          this.$refs.player.play({ src: sound.media_url, name: sound.name })
        } catch (error) {
          this.$message.error(`获取试听地址失败：${error?.message || '网络异常'}`)
        }
      },
      selectFileChange(file){
        this.$set(this.form,'sound',file.raw)
        // 2026-10-11：编辑页更换文件只替换音频内容，不覆盖已经维护好的音效名称。
        // 例如“开门声”改传 repair.mp3 后，标题仍保持“开门声”。
        // 永远只展示最后选择的一个资源。
        this.selectedFileList = [file]

        this.upload.state = 'idle'
        this.upload.status = undefined
      },
      fileExceed(){
        this.$message({type:"info",message:"一次只能上传一个"})
      },
      
      fileRemove(){
        console.log("fileRemove")
        this.$set(this.form,'sound',null)
      },
      clearSelectedFiles(errorMsg){ 
        this.selectedFileList = []
        this.$refs.uploadHandler.clearFiles()
        this.$set(this.form,'sound',null)
        this.$alert(errorMsg + "\t" + "已清空选择的文件，请重新选择要上传的文件。", "提示",{
          confirmButtonText: '确定',
          callback: action => {
            if (action === 'confirm') {
                this.upload.state = 'idle'
                this.upload.status = undefined
            }
          }
        })
      },
      onLinkTypeChange(val) {
        if (val === 'netease') {
          // 如果用户之前在 full_path 粘贴过整条网易云链接，则尝试自动提取 id
          const m = (this.form.full_path || '').match(/id=(\d+)/)
          if (m) this.netease_id = m[1]
          if (!this.netease_id) this.form.full_path = this.NETEASE_PREFIX
        }
      },
      // 只允许数字，避免把非数字字符带进 ID
      onlyDigits(field) {
        this.form[field] = (this.form[field] || '').replace(/\D/g, '')
      },
      // 粘贴整条链接时自动截出 id
      parseNeteasePaste(e) {
        const text = (e.clipboardData || window.clipboardData).getData('text') || ''
        const m = text.match(/id=(\d+)/)
        if (m) {
          e.preventDefault()
          this.netease_id = m[1]
        }
      },
      readOneSound(){
        const loading = this.$loading({
          lock: true,
          text: '获取数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        let p = this.$route.params.obj || {id:this.$route.query.id};
        if(!p.id) return;
        console.log(p)
        apis.sounds.readOneSound({id:p.id}).then(res=>{
          console.log('res',res)
          const data = res?.data?.data;
          if(!data) {
            this.$message({message:'获取资源详情失败', type:'error',duration:0,showClose: true})
            loading.close();
            return
          }

          const full_path = data?.full_path || '';
          this.addSourceType = data.media_source === 'external'
            ? 'linkUrl'
            : 'localFile';
          this.originalSourceType = this.addSourceType;

          //如果full_path是网易云外链
          if(full_path && full_path.startsWith(this.NETEASE_PREFIX)){
            this.link_type = 'netease';
            this.netease_id = full_path.replace(this.NETEASE_PREFIX,'');
          }else{
            this.link_type = 'custom';
            this.form.full_path = full_path;
          }


          // 2026-09-28：把试听地址交给播放器；media_url 仍只供展示和试听，
          // 保存时会从 FormData 中排除，不能作为持久化外链写回数据库。
          this.currSrc = data.media_url || ''
          this.form = { ...data, full_path }
          loading.close();
        }).catch(err=>{
          loading.close();
          console.log('err',err)
        })
      },
    },
    mounted(){
        this.getCategoryList()
        this.readOneSound();
        console.log('mounted',this.$route)
    },
    created(){
      console.log('created',this.$route)
    },
    computed:{
      isLinkType(){
        return !!(this.addSourceType && this.addSourceType === 'linkUrl')
      },
      etaText(){
        if (!this.upload.speed || !this.upload.total) return '--'
        const remain = Math.max(0, this.upload.total - this.upload.loaded)
        const sec = Math.max(1, Math.round(remain / this.upload.speed))
        const m = Math.floor(sec / 60), s = sec % 60
        return m ? `${m}分${s}秒` : `${s}秒`
      },
      // 统一产出最终地址；同时用于预览
      computedFullPath() {
        return this.link_type === 'netease'
          ? this.NETEASE_PREFIX + (this.netease_id || '')
          : (this.form.full_path || '')
      }
    },
    watch:{
      // 保持 form.full_path 与选择结果同步，后端永远拿 full_path
      computedFullPath(newVal) {
        this.form.full_path = newVal
      }
    }
}
</script>

<style lang="scss">
.add-pro-wrapper{
  .add-pro-content{
    box-sizing: border-box;
    width: 100%;
    padding:15px;
  }
  .box-card{
    margin-bottom:16px;
  }
  .part-info{
    // @include flex_ccc();
    // background: brown;
    .title{
      font-size: 18px;
      color:#333;
    }
    .info{
      font-size: 12px;
      color:#999;
    }
  }
}
.audio-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 20px;
}
.source-type-selector {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.source-type-label {
  color: #606266;
  font-size: 14px;
}
.source-type-help {
  color: #909399;
  font-size: 12px;
}
.source-switch-alert {
  margin-top: 10px;
}
.audio-preview-title {
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}
.audio-preview-help {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
}
.audio-preview-player {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}
.sound-metadata-card {
  .metadata-card-tip {
    margin-left: 10px;
    color: #909399;
    font-size: 12px;
    font-weight: 400;
  }
}
.resource-summary {
  .resource-summary-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
  }
  .resource-summary-label {
    flex: 0 0 72px;
    color: #909399;
  }
  .resource-summary-path {
    color: #606266;
    overflow-wrap: anywhere;
    word-break: break-all;
  }
  .resource-summary-alert {
    margin-top: 4px;
  }
}
/* 新增：上传进度小面板 */
.upload-progress {
  margin-top: 10px;
  border: 1px dashed var(--el-border-color, #dcdfe6);
  border-radius: 8px;
  padding: 10px 12px;
  .up-head, .up-row {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
  }
  .up-name { 
    font-weight: 600; 
    max-width: 70%; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    white-space: nowrap; 
    color: #606266; 
  }
  .up-ops { margin-top: 6px; }
}
</style>
